export default function clearLocalStorage() {
  window.localStorage.clear()
}
